import { ColorInput, type ColorInputProps } from '@mantine/core';
import type { Except, Merge, SetRequired } from 'type-fest';
import { useCommonInputProps } from '../../../hooks/useCommonInputProps';
import type { Controlled_ValidatedInputProps } from './types';

export type Controlled_ColorInputProps<N extends boolean> = Merge<
    Except<
        SetRequired<ColorInputProps, 'readOnly'>,
        'styles' | 'rightSectionWidth' | 'rightSection'
    >,
    Controlled_ValidatedInputProps<N, string>
>;

export const Controlled_ColorInput = <N extends boolean>({
    nullable,
    value,
    onChange,
    label: _label,
    labelInfo,
    severity,
    helperText,
    endingIcon,
    w,
    placeholder: _placeholder,
    readOnly,
    nullableInReadOnly,
    ...props
}: Controlled_ColorInputProps<N>) => {
    const { rightSectionWidth, rightSection, inputStyles, label, placeholder } =
        useCommonInputProps({
            endingIcon,
            severity,
            helperText,
            nullable,
            onChange,
            value,
            label: _label,
            labelInfo,
            placeholder: _placeholder,
            readOnly,
            nullableInReadOnly,
        });

    return (
        <ColorInput
            {...props}
            readOnly={readOnly}
            value={value ?? ''}
            w={w ?? '100%'}
            label={label}
            placeholder={placeholder}
            rightSectionWidth={rightSectionWidth}
            rightSection={rightSection}
            styles={{
                input: inputStyles,
                // section: {
                //     display: 'flex',
                //     justifyContent: 'flex-end',
                // },
            }}
            onChange={onChange}
            swatches={[
                '#2e2e2e',
                '#868e96',
                '#fa5252',
                '#e64980',
                '#be4bdb',
                '#7950f2',
                '#4c6ef5',
                '#228be6',
                '#15aabf',
                '#12b886',
                '#40c057',
                '#82c91e',
                '#fab005',
                '#fd7e14',
            ]}
        />
    );
};
